import { useState } from 'react';

import { api } from '../api';
import { useResultStore } from '../store/resultStore';

const successText = 'Success!';

export function useRefreshAppSetting() {
	const [loading, setLoading] = useState(false);
	const open = useResultStore((state) => state.open);

	const refresh = async () => {
		try {
			setLoading(true);
			const { data } = await api.refreshAppSetting();
			const { returnCode, message } = data;
			if (returnCode !== '0') throw new Error(message);
			open({ type: 'success', text: successText });
		} catch (err) {
			open({ type: 'error', text: err.message });
		} finally {
			setLoading(false);
		}
	};

	return { refresh, loading };
}
